export { default as useUncontrolled, useUncontrolledProp } from './hook';
export { default as uncontrollable } from './uncontrollable';


//////////////////
// WEBPACK FOOTER
// ./~/uncontrollable/esm/index.js
// module id = 66
// module chunks = 0